export default class Port {
    constructor(code, countryCode, name, lat, lon, locode) {
        this.code = code,
            this.countryCode = countryCode,
            this.name = name,
            this.lat = lat,
            this.lon = lon,
            this.locode = locode
    }
}